import React, { memo, useMemo } from "react";
import { Typography } from "antd";
import NewsInfo from "@/app/components/NewsInfo";
import { NewsFromProjectCategory, sanitizeHtmlContent } from "@/helpers";
import { IMAGE_SHARE_CDN } from "@/constant/apiPath";
import imageBlog from "@/asset/images/image-blog.png";
import imageExample from "@/asset/images/image-example.png";
import type { INewsResponse } from "@/models/news";
import { Skeleton } from "antd/lib";
import classNames from "classnames";
import Link from "next/link";
import { useLanguageContext } from "@/context/LanguageContext";

const MainNews = ({
  news,
  isLoading,
  isHideDesc,
  imageClassName,
}: {
  news?: INewsResponse;
  isLoading?: boolean;
  isHideDesc?: boolean;
  imageClassName?: string;
}) => {
  const { language } = useLanguageContext();

  const title = useMemo(() => sanitizeHtmlContent(news?.title || news?.description || ""), [news]);

  const description = useMemo(() => sanitizeHtmlContent(news?.description || news?.content || ""), [news]);

  const imageUrl = useMemo(() => {
    if (news?.is_klarda) {
      return `${IMAGE_SHARE_CDN}${news?.thumbnail}`;
    }
    return news?.thumbnail || (news?.klarda_categories?.includes(NewsFromProjectCategory) ? imageBlog : imageExample);
  }, [news]);
  if (isLoading) return <Skeleton paragraph={{ rows: 5 }} />;

  return (
    <div className="flex flex-col gap-4 mycard-hover rounded p-1" key={news?.id}>
      <Link href={news?.is_klarda ? `/${language}/news/blogs/${news?.link}` : `/${language}/news/${news?.id}`} passHref>
        <img
          onError={e => {
            e.currentTarget.src = "https://d37pr5wbjsk01d.cloudfront.net/1725547867815.png";
          }}
          src={imageUrl as string}
          alt={title}
          className={classNames(`rounded w-full ${imageClassName ?? ""}`)}
        />
      </Link>
      <div className="flex flex-col gap-4 justify-between flex-1">
        <div className="space-y-1">
          <Typography.Link
            title={title}
            href={news?.is_klarda ? `/${language}/news/blogs/${news?.link}` : `/${language}/news/${news?.id}`}
          >
            <Typography.Title level={5} className="line-clamp-2 m-0">
              <div dangerouslySetInnerHTML={{ __html: title }} />
            </Typography.Title>
          </Typography.Link>
          {!isHideDesc && (
            <Typography.Text title={description} type="secondary" className="line-clamp-2">
              <div dangerouslySetInnerHTML={{ __html: description }} />
            </Typography.Text>
          )}
        </div>
        {news && <NewsInfo news={news} />}
      </div>
    </div>
  );
};

export default memo(MainNews);
